__turbopack_context__.v({
  "active": "Tabs-module-scss-module__HbYM-W__active",
  "tab": "Tabs-module-scss-module__HbYM-W__tab",
  "tabs": "Tabs-module-scss-module__HbYM-W__tabs",
});
